import { createApiRequest } from "@/lib/api/createApiService";
import { QUESTION_LIBRARY_ENDPOINTS } from "./question-library.endpoints";

export const questionLibraryService = {
  listQuestions: async (params = {}, options = {}) => {
    return createApiRequest({
      url: QUESTION_LIBRARY_ENDPOINTS.LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },

  createQuestion: async (payload, options = {}) => {
    return createApiRequest({
      url: QUESTION_LIBRARY_ENDPOINTS.CREATE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateQuestion: async (id, payload, options = {}) => {
    return createApiRequest({
      url: QUESTION_LIBRARY_ENDPOINTS.UPDATE(id),
      method: "PUT",
      body: payload,
      ...options,
    });
  },

  toggleFavourite: async (id, options = {}) => {
    return createApiRequest({
      url: QUESTION_LIBRARY_ENDPOINTS.TOGGLE_FAVOURITE(id),
      method: "PATCH",
      ...options,
    });
  },

  toggleArchive: async (id, options = {}) => {
    return createApiRequest({
      url: QUESTION_LIBRARY_ENDPOINTS.TOGGLE_ARCHIVE(id),
      method: "PATCH",
      ...options,
    });
  },

  deleteQuestion: async (id, options = {}) => {
    return createApiRequest({
      url: QUESTION_LIBRARY_ENDPOINTS.DELETE(id),
      method: "DELETE",
      ...options,
    });
  },
};
